import { useLanguage } from "@/LanguageContext";
import { motion } from "framer-motion";
import { Eye, Award, Heart } from "lucide-react";

const valueIcons = [Eye, Award, Heart];

export default function ValuesSection() {
  const { t } = useLanguage();
  const items = t("values.items");

  return (
    <section
      id="values"
      data-testid="values-section"
      className="py-24 lg:py-32 bg-[#E8E0D4]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="text-sm font-body uppercase tracking-[0.2em] text-[#6FA8B6] mb-4">
            {t("values.label")}
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#2C3E50]">
            {t("values.title")}
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {Array.isArray(items) &&
            items.map((item, i) => {
              const Icon = valueIcons[i];
              return (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-50px" }}
                  transition={{ duration: 0.5, delay: i * 0.15 }}
                  className="text-center p-8"
                  data-testid={`value-card-${i}`}
                >
                  <div className="w-16 h-16 mx-auto mb-6 bg-[#6FA8B6]/10 rounded-2xl flex items-center justify-center">
                    <Icon
                      size={28}
                      className="text-[#6FA8B6]"
                      strokeWidth={1.5}
                    />
                  </div>
                  <h3 className="font-heading text-2xl sm:text-3xl text-[#2C3E50] mb-4">
                    {item.title}
                  </h3>
                  <p className="font-body text-sm text-[#2C3E50]/60 leading-relaxed max-w-xs mx-auto">
                    {item.description}
                  </p>
                </motion.div>
              );
            })}
        </div>
      </div>
    </section>
  );
}
